export function initProductForm() {
	const form = document.getElementById("js-product-form-ajax");
	const input = document.getElementById("js-quantity");
	const plus = document.getElementById("js-increase-qty");
	const minus = document.getElementById("js-decrease-qty");
	const select = document.getElementById("js-variant-id");

	if (!form || !input) return;

	// Helpers limiti
	const hasNum = (v) =>
		v !== undefined && v !== null && v !== "" && !isNaN(parseInt(v, 10));
	function getBoundsFromInput() {
		const min = hasNum(input.min) ? parseInt(input.min, 10) : 1;
		const step = 1; // fisso a 1
		const max =
			input.hasAttribute("max") && hasNum(input.max)
				? parseInt(input.max, 10)
				: Infinity;
		return { min, step, max };
	}
	function clamp(val, min, max) {
		return Math.max(min, Math.min(max, val));
	}

	// Applica limiti dall'option selezionata
	function applyVariantQtyRulesFromOption(opt) {
		if (!opt) return;
		const min = parseInt(opt.dataset.min || "1", 10);
		const hasMx =
			typeof opt.dataset.max !== "undefined" && opt.dataset.max !== "";
		const max = hasMx ? parseInt(opt.dataset.max, 10) : null;

		input.min = String(min);
		input.step = "1";
		if (hasMx && Number.isFinite(max)) input.max = String(max);
		else input.removeAttribute("max");

		const { min: m, max: M } = getBoundsFromInput();
		const current = parseInt(input.value || "1", 10);
		input.value = String(
			clamp(Number.isFinite(current) ? current : m, m, M)
		);
	}

	// Inizializza limiti per la variante corrente
	if (select) {
		const selected = select.options[select.selectedIndex];
		if (selected) applyVariantQtyRulesFromOption(selected);

		// Quando cambia variante (anche programmatico da productFormVariant)
		if (!select.classList.contains("js-bound")) {
			select.classList.add("js-bound");
			select.addEventListener("change", () => {
				const opt = select.options[select.selectedIndex];
				applyVariantQtyRulesFromOption(opt);
			});
		}
	}

	// Bind-once: +
	if (plus && !plus.classList.contains("js-bound")) {
		plus.classList.add("js-bound");
		plus.addEventListener("click", () => {
			const { min, step, max } = getBoundsFromInput();
			const current = parseInt(input.value || String(min), 10);
			const next = clamp(current + step, min, max);
			input.value = String(next);
		});
	}

	// Bind-once: –
	if (minus && !minus.classList.contains("js-bound")) {
		minus.classList.add("js-bound");
		minus.addEventListener("click", () => {
			const { min, step, max } = getBoundsFromInput();
			const current = parseInt(input.value || String(min), 10);
			const next = clamp(current - step, min, max);
			input.value = String(next);
		});
	}

	// Bind-once: digitazione manuale
	if (!input.classList.contains("js-bound")) {
		input.classList.add("js-bound");
		const onType = () => {
			const { min, max } = getBoundsFromInput();
			let val = parseInt(input.value, 10);
			if (!Number.isFinite(val)) val = min;
			input.value = String(clamp(val, min, max));
		};
		input.addEventListener("input", onType);
		input.addEventListener("change", onType);
	}

	// Submit AJAX esistente: clamp finale di sicurezza
	if (!form.classList.contains("js-bound")) {
		form.classList.add("js-bound");
		form.addEventListener("submit", async function (e) {
			e.preventDefault();
			const submitButton = document.getElementById(
				"js-add-to-cart-button"
			);

			const { min, max } = getBoundsFromInput();
			input.value = String(
				clamp(parseInt(input.value || "1", 10), min, max)
			);

			const formData = new FormData(form);
			submitButton?.classList.add("is-loading");

			try {
				const response = await fetch("/cart/add.js", {
					method: "POST",
					headers: { Accept: "application/json" },
					body: formData,
				});

				if (response.ok) {
					const item = await response.json();

					// Aggiorna badge carrello
					const cartCount = document.getElementById("js-cart-count");
					if (cartCount) {
						fetch("/cart.js")
							.then((res) => res.json())
							.then((cart) => {
								cartCount.innerHTML =
									cart.item_count > 0
										? `<span class="bg-accent text-white font-bold p-1 rounded">${cart.item_count}</span>`
										: "";
								document.dispatchEvent(
									new CustomEvent("cart:updated", {
										detail: { cart },
									})
								);
							});
					}

					// Feedback laterale (il tuo UI)
					const feedback =
						document.getElementById("js-cart-feedback");
					const title = document.getElementById(
						"js-cart-feedback-title"
					);
					const image = document.getElementById(
						"js-cart-feedback-image"
					);
					const qty = document.getElementById(
						"js-cart-feedback-quantity"
					);
					const variant = document.getElementById(
						"js-cart-feedback-variant"
					);

					if (feedback && title && image && qty && variant) {
						title.innerText = item.product_title;
						qty.innerText = item.quantity;
						image.src = item.image || "";
						image.alt = item.product_title;

						if (
							item.variant_title &&
							item.variant_title !== "Default Title"
						) {
							variant.innerText = item.variant_title;
							variant.classList.remove("hidden");
						} else {
							variant.innerText = "";
							variant.classList.add("hidden");
						}
						feedback.classList.remove("hidden");
					}

					document.dispatchEvent(new CustomEvent("cart:open"));
				} else {
					const error = await response.json();
					alert(error.description || "Errore aggiunta al carrello");
				}
			} catch (err) {
				console.error("Errore AJAX carrello:", err);
			} finally {
				submitButton?.classList.remove("is-loading");
			}
		});
	}
}
